import {AttachMoney} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const expensesRecords = {
    id: 'expensesRecords',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'expensesRecords',
            title: 'Expenses Records',
            type: 'item',
            url: '/expensesRecords',
            icon: AttachMoney,
            breadcrumbs: false,
            
        },
       
    ]
};

export default expensesRecords;
